export type Page<T> = {
    total: number;
    total_pages: number;
    has_next: boolean;
    has_previous: boolean;
    is_first: boolean;
    is_last: boolean;
    page: number;
    size: number;
    content: T[];
};

export const emptyPage = <T>() => {
    return {
        total: 0,
        total_pages: 0,
        has_next: false,
        has_previous: false,
        is_first: false,
        is_last: false,
        page: 0,
        size: 10,
        content: new Array<T>()
    };
};

export const getPageFromList = <T>(items: T[], page: number, size: number): Page<T> => {
    const totalPages = Math.ceil(items.length / size);

    return {
        total: items.length,
        total_pages: totalPages,
        has_next: page + 1 < totalPages,
        has_previous: page > 0,
        is_first: page === 0,
        is_last: page === totalPages - 1,
        size: size,
        page: page,
        content: items.slice(page * size, (page + 1) * size)
    };
};
